import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios'
import Swal from 'sweetalert2'
import {useToken} from '@/core/utils/token'
import {useIntendedRedirect} from '@/core/utils/intendedRedirect'

let sessionExpiredHandled = false

export const resetSessionExpired = (): void => {
    sessionExpiredHandled = false
}

const handleSessionExpired = (): void => {
    if (sessionExpiredHandled) return
    sessionExpiredHandled = true

    useToken().clearToken()
    useIntendedRedirect().set(window.location.pathname + window.location.search)

    Swal.fire({
        title: 'Sitzung abgelaufen',
        text: 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.',
        icon: 'warning',
        allowOutsideClick: false,
        confirmButtonText: 'Zum Login',
    }).then(() => {
        window.location.href = '/'
    })
}

export const useHttp = () => {

    let token = useToken().getToken()

    const http = axios.create({
        baseURL: <string>import.meta.env.VITE_API_URL,
        headers: {
            'Accept': 'application/json',
            'Authorization': token ? `Bearer ${token}` : '',
        }
    })

    const get = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('get', url, payload, config)
    }

    const post = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('post', url, payload, config)
    }

    const put = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('put', url, payload, config)
    }

    const patch = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('patch', url, payload, config)
    }

    const destroy = <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
        return request('delete', url, config)
    }

    const request = <T>(method: any, url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        const requestConfig: AxiosRequestConfig = {
            url: url,
            method,
            [method === 'get' ? 'params' : 'data']: payload,
            ...config
        }

        return new Promise<T>((resolve, reject) => {
            http.request(requestConfig)
                .then((response: AxiosResponse) => {
                    resolve(response.data as T)
                })
                .catch((error: AxiosError) => {
                    if (error.response?.status === 401) {
                        handleSessionExpired()
                    }
                    reject(error.response)
                })
        })
    }

    return {
        get,
        post,
        put,
        patch,
        destroy,
        request
    }
}
